/*eslint no-extend-native: ["error", { "exceptions": ["String"] }]*/
String.prototype.supplant = function (obj: { [key: string]: string }) {
    return this.replace(/{([^{}]*)}/g,
        function (a, b) {
            var r = obj[b];
            return typeof r === "string" || typeof r === "number" ? r : a;
        }
    );
};



// WEBPACK FOOTER //
// ./src/Utils/Polyfills.js